import { toOption } from '@common/selectOptions.services';
import { IOption } from '@gcl/react-core';
import { RowState } from '@gcl/react-core/dist/components/Table/UnstyledTableComponents/Layout/VerticalTableLayout';
import { IProjectTransmittalItemRevision } from '@transmittal/transmittalItemRevision/transmittalItemRevision.models';
import React, { Dispatch, SetStateAction } from 'react';
import { object, setLocale, string } from 'yup';
import { QueryKey } from '@tanstack/react-query';
import {
  ETransmittalItemTableFormKey,
  TRANSMITTAL_ITEM_REVISION_NOT_ISSUE_KEY,
} from './transmittalItemTableForm.constants';

setLocale({
  mixed: {
    required: (params) => {
      return { key: params.path, message: 'This field is required' };
    },
  },
});
export const transmittalItemRevisionSchema = object({
  item: object({
    docNo: string().required(),
    description: string().required(),
  }),
  revisionNo: string().when('projectFile', ([projectFile], schema) => {
    if (projectFile === null) return schema;
    return schema.required();
  }),
});

export interface ITransmittalItemTableFormState {
  [ETransmittalItemTableFormKey.docNo]: string | null;
  [ETransmittalItemTableFormKey.description]: string | null;
  [ETransmittalItemTableFormKey.revisionNo]: string | null;
}

export const convertIssueDropdownOptions: (
  issuableRevisions: IProjectTransmittalItemRevision[],
) => IOption<IProjectTransmittalItemRevision | undefined>[] = (issuableRevisions) => {
  const options = issuableRevisions.map((issuableRevision) => {
    return toOption(issuableRevision, 'id', 'revisionNo');
  });
  options.push({
    key: TRANSMITTAL_ITEM_REVISION_NOT_ISSUE_KEY,
    text: 'Not Issue',
    data: undefined,
  });

  return options;
};

export interface ITransmittalItemTableEditingRef {
  [key: number]: ITransmittalItemTableEditingEvents;
}
export interface ITransmittalItemTableEditingEvents {
  tableRef: React.MutableRefObject<ITransmittalItemRowEditingRef>;
  queryKey: QueryKey;
  setRowUploading: (index: number, isUploading: boolean) => void;
}
export interface ITransmittalItemRowEditingRef {
  [key: number]: ITransmittalItemRowEditingEvents;
}
export interface ITransmittalItemRowEditingEvents {
  rowState: RowState;
  setRowState?: (value: React.SetStateAction<RowState>) => void;
  setUploadProgress: Dispatch<SetStateAction<number | undefined>> | undefined;
}
export interface ITransmittalItemRowIssuableRevisionRef {
  [key: number]: {
    onIssueLatestRevision: () => void;
    isLatestRevision: boolean;
  };
}

export interface ITransmittalItemRowTransmittalRevisionApprovalRef {
  [key: number]: {
    setIsSelectedForApproval: React.Dispatch<React.SetStateAction<boolean | undefined>>;
    isSelectedForApproval: boolean | undefined;
    isInUse: boolean;
  };
}
